const updateResizeProps = (status) => { 
  return {
    type: 'UPDATE_RESIZE_PROPERTIES',
    payload: status,
  }
}

export {
  updateResizeProps,
}